export default {
  methods: {
    scrollItem (num) {
      let top = 0
      if(num === 0) {
        top = this.$refs.lessonItemOne.offsetTop - 60
      }else if(num === 1){
        top = this.$refs.lessonItemTwo.offsetTop  - 60
      }else if(num === 2){
        top = this.$refs.lessonItemThree.offsetTop  - 60
      }
      window.scrollTo({
        top,
        behavior: "smooth"
      })
    }
  }
}